import { Variant, type LoadWidgetProps } from '@asurion-core/widget-client/lib/package';

export type WidgetParams<V extends Variant = Variant> = LoadWidgetProps<V> & {
  variant: V;
};

const HASH_KEY = 'si-wid-hos-widget-props';

export const INITIAL_WIDGET_PARAMS: WidgetParams = {
  id: '',
  variant: Variant.FLOATING_ACTION_CARD,
};

const currentHashParams = (): URLSearchParams => new URLSearchParams(window.location.hash.slice(1));

const buildUrlWithHash = (params: URLSearchParams): string => {
  const encoded = params.toString();
  const hash = encoded ? `#${encoded}` : '';
  return `${window.location.pathname}${window.location.search}${hash}`;
};

export const readWidgetParamsFromHash = (): WidgetParams => {
  if (typeof window === 'undefined') return INITIAL_WIDGET_PARAMS;
  const raw = currentHashParams().get(HASH_KEY);
  if (!raw) return INITIAL_WIDGET_PARAMS;
  try {
    return JSON.parse(raw) as WidgetParams;
  } catch {
    return INITIAL_WIDGET_PARAMS;
  }
};

export const writeWidgetParamsToHash = (params: WidgetParams): void => {
  if (typeof window === 'undefined') return;
  const search = currentHashParams();
  search.set(HASH_KEY, JSON.stringify(params));
  const next = buildUrlWithHash(search);
  if (`${window.location.pathname}${window.location.search}${window.location.hash}` === next) return;
  window.history.pushState(null, '', next);
};
